let contactForm
function vueContactForm() {
    contactForm = Vue.createApp({
        delimiters: ['#{', '}'],
        setup() {
            const form = Vue.reactive(formConfig)

            const stores = async () => {
                const req = `{
	                locations(first:250) {
		                edges {
			                node {
				                name
			                }
		                }
	                }
                }`
                const options = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                    },
                    body: JSON.stringify({ query: req })
                };
                try {
                    const storeListResponse = await fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options);
                    let storeList = await storeListResponse.json();
                    storeList.data.locations.edges = storeList?.data?.locations?.edges?.filter(edge => !edge?.node?.name?.includes("pre-order") && !edge?.node?.name?.includes("warehouse"))
                    return storeList;
                } catch (error) {
                    console.error(error);
                    return ('error')
                }
            }

            stores().then(response => {
                if (response == 'error') {
                    return
                } else {
                    response.data.locations.edges.sort((a, b) => a.node.name.localeCompare(b.node.name))
                    let idx = form.findIndex(item => item.key == "store_name")
                    if (idx > -1) {
                        for (let i = 0; i < response.data.locations.edges.length; i++) {
                            form[idx].options.push(response.data.locations.edges[i].node.name)
                        }
                    }
                    const storeSelector = window.storeSelector()
                    if (storeSelector?.nearestStore?.node?.name) {
                        form[idx].value = storeSelector.nearestStore.node.name
                    }
                }
            })

            let formData = {
                name: "",
                phone_number: "",
                store_name: "",
                email: "",
                post_code: "",
                comment: "",
                enquiry_type: ""
            };

            if (localStorage.getItem('storeEnquiry') && contactType == 'general') {
                let enquiry = JSON.parse(localStorage.getItem('storeEnquiry'))
                let idx = form.findIndex(item => item.key == "comment")
                if (idx > -1) {
                    if (enquiry.splitTitle && enquiry.splitSku) {
                        form[idx].value = `Stock Enquiry\nTitle: ${enquiry.title}\nSKU: ${enquiry.sku}\nStaggered Title: ${enquiry.splitTitle}\nStaggered SKU: ${enquiry.splitSku}`;
                    } else {
                        form[idx].value = `Stock Enquiry\nTitle: ${enquiry.title}\nSKU: ${enquiry.sku}`;
                    }
                }
                localStorage.removeItem('storeEnquiry')
            }

            const showThankYou = Vue.ref(false);
            const showFail = Vue.ref(false);
            const submitLoad = Vue.ref(false);

            const toggleThankYou = () => {
                showThankYou.value = !showThankYou.value
            }

            const exitError = () => {
                showFail.value = !showFail.value
            }

            const submit = async () => {
                submitLoad.value = true;
                let acceptable = true;
                for (let i = 0; i < form.length; i++) {
                    if (form[i].value == "") {
                        if (form[i].required) {
                            acceptable = false;
                            form[i].highlight = true;
                        }
                    } else {
                        if (form[i].key === "post_code") {
                            if (isNaN(form[i].value)) {
                                acceptable = false;
                                form[i].highlight = true;
                            } else {
                                form[i].highlight = false;
                                formData[form[i].key] = Number(form[i].value);
                            }
                        } else {
                            form[i].highlight = false;
                            formData[form[i].key] = form[i].value;
                        }
                    }
                }
                if (acceptable) {
                    try {
                        const response = await fetch(contactConfig.endpoint, {
                            method: 'POST',
                            headers: {
                                'api-token': contactConfig.token,
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(formData)
                        });
                        if (response.status == 500) {
                            showFail.value = true;
                            submitLoad.value = false;
                            return null;
                        }
                        if (response.ok) {
                            showThankYou.value = true;
                            submitLoad.value = false;
                            try {
                                const data = await response.json();
                                return typeof data?.enquiry_id === 'string' || typeof data?.enquiry_id === 'number' ? data.enquiry_id : null;
                            } catch (error) {
                                return null;
                            }
                        } else {
                            showFail.value = true;
                            submitLoad.value = false;
                            return null;
                        }
                    } catch (error) {
                        console.error(error);
                        showFail.value = true;
                        submitLoad.value = false;
                        return null;
                    }
                } else {
                    submitLoad.value = false;
                    return null;
                }
            }

            const openChat = (enquiryId) => {
                if (contactType !== 'general') return;
                const overlay = document.querySelector('agent-overlay-component');
                if (!overlay || typeof overlay.openWithMessage !== 'function') return;
                showThankYou.value = false;
                const filledIn = form.filter((entry) => String(entry.value ?? '').trim() !== '');
                if (!filledIn.length) {
                    overlay.open();
                    return;
                }
                const summary = filledIn.map((entry) => `${entry.header}: ${entry.value}`).join('\n');
                const hiddenContext = `ENQUIRY_ID: ${enquiryId || ''}`;
                overlay.openWithMessage(`The customer submitted an enquiry through the contact form:\n${summary}`, hiddenContext);
            }

            const submitAndOpenChat = async () => {
                const enquiryId = await submit();
                openChat(enquiryId);
            }

            const linkNumber = Vue.computed(() => {
                const nearStore = localStorage.getItem('currentNearestStore');
                if(!nearStore) return false;
                try{
                    const parsed = JSON.parse(nearStore);
                    if(!parsed?.node?.phoneLink) return false;
                    return parsed.node.phoneLink;
                } catch(e) {
                    return false;
                }
            });

            const digitNumber = Vue.computed(() => {
                const nearStore = localStorage.getItem('currentNearestStore');
                if(!nearStore) return false;
                try{
                    const parsed = JSON.parse(nearStore);
                    if(!parsed?.node?.phoneLink) return false;
                    const parsedReduced = parsed.node.phoneLink.replace('tel:','').replace('+61','');
                    console.log(parsedReduced)
                    if(parsedReduced.length === 9) return `(0${parsedReduced.substring(0,1)}) ${parsedReduced.substring(1,5)} ${parsedReduced.substring(5,parsedReduced.length)}`;
                    return `0${parsedReduced}`;
                } catch(e) {
                    return false;
                }
            });

            return {
                form, submit, showThankYou, toggleThankYou, exitError, showFail, submitLoad, linkNumber, digitNumber, openChat, submitAndOpenChat
            };
        }
    })
    contactForm.use(window.VueAppGlobals.pinia);
    contactForm.mount('#contactForm');
}

if (window.Vue && window.Pinia) {
    vueContactForm();
} else {
    window.addEventListener('vue-ready', function () {
        vueContactForm();
    });
}